import React from "react";
import { Route, Routes } from "react-router-dom";
import {
  RootPage
} from "../pages";
import { Routes as AppRoutes } from "../types/NavigationPaths";
import { Main } from "./Main";

export const MainLayout: React.FC = () => {
  return (
    <Main>
      <Routes>
        <Route Component={RootPage} path={AppRoutes.ROOT} />
      </Routes>
    </Main>
  );
};
